import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopyIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 27 32",
	style: { enableBackground: "new 0 0 27 32" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.copy-icon-st1{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "copy-icon-st1",
			d: "M19.8,31H2.2c-0.3,0-0.6-0.1-0.9-0.4C1.1,30.4,1,30.1,1,29.8V7.2c0-0.3,0.1-0.6,0.4-0.9C1.6,6.1,1.9,6,2.2,6 h12.5l6.2,6.2v17.5c0,0.3-0.1,0.6-0.4,0.9C20.4,30.9,20.1,31,19.8,31z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "copy-icon-st1",
			d: "M6,6V2.2c0-0.3,0.1-0.6,0.4-0.9C6.6,1.1,6.9,1,7.2,1h12.5L26,7.2v17.5c0,0.3-0.1,0.6-0.4,0.9 C25.4,25.8,25,26,24.7,26H21"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "copy-icon-st1",
			d: "M7.2,19.8h7.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "copy-icon-st1",
			d: "M7.2,24.8h7.5"
		})
	] }) })]
});
export default SvgCopyIcon;
